import { lighten, Theme } from "@mui/material";
import { Breakpoints, SxProps } from "@mui/system";
import { COLORS } from "../../../constants/colors";

export const baseChipStylesFn = ({
  hideBgMobile,
  breakpoints,
}: {
  hideBgMobile?: boolean;
  breakpoints: Breakpoints;
}): SxProps<Theme> => ({
  color: COLORS.BLACK,
  backgroundColor: (theme) => lighten(theme.palette.primary.main, 0.88), // .12
  "&:hover": {
    backgroundColor: (theme) => lighten(theme.palette.primary.main, 0.84), // .16
  },
  "&:focus": {
    backgroundColor: (theme) => lighten(theme.palette.primary.main, 0.76), //  .24
  },
  "& > .MuiTouchRipple-root": {
    color: "primary.main",
  },
  [breakpoints.down("sm")]: {
    ...(hideBgMobile && { background: "none !important" }),
    ...(hideBgMobile && { boxShadow: "none !important" }),
  },
  "&.Mui-disabled": {
    background: COLORS.LIGHT_GREY,
    opacity: 1,
    color: COLORS.P_DISABLED,

    ".MuiChip-deleteIcon": {
      color: COLORS.P_OUTLINE,
    },
  },
  "&.MuiChip-sizeSmall": {
    fontSize: "12px",
  },
  "&.MuiChip-sizeMedium": {
    fontSize: "14px",
  },
  ".MuiChip-icon": {
    width: "18px",
    height: "18px",
  },
  ".MuiChip-deleteIcon": {
    height: "18px",
    width: "18px",
    marginRight: "8px",
    color: "rgba(0, 0, 0, 0.5)",
  },
  "&.MuiChip-outlined": {
    backgroundColor: COLORS.WHITE,
    border: (theme) => `1px solid ${theme.palette.primary.main}`,
    "&:hover": {
      backgroundColor: (theme) => lighten(theme.palette.primary.main, 0.96), // .04
    },
    "&:focus": {
      backgroundColor: (theme) => lighten(theme.palette.primary.main, 0.88), // .12
    },
    "&.Mui-disabled": {
      background: COLORS.WHITE,
      border: "1px solid rgba(0, 0, 0, 0.12)",
      color: COLORS.P_DISABLED,
    },
  },
});

export const chipTypeStyles = {
  defaultDragged: {
    "&.MuiChip-root": {
      backgroundColor: (theme: Theme): string =>
        lighten(theme.palette.primary.main, 0.8), // .20
      boxShadow:
        "0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)",
    },
  },
  outlinedDragged: {
    "&.MuiChip-root&.MuiChip-outlined": {
      backgroundColor: (theme: Theme): string =>
        lighten(theme.palette.primary.main, 0.92), // .08
      boxShadow:
        "0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)",
    },
  },
  filterDefaultSelected: {
    "&.MuiChip-root": {
      border: (theme: Theme): string =>
        `1px solid ${theme.palette.primary.main}`,
      color: "primary.main",
      backgroundColor: (theme: Theme): string =>
        lighten(theme.palette.primary.main, 0.92),
    },
  },
  filterDefaultSelectedWithIcon: {
    "&.MuiChip-root": {
      backgroundColor: (theme: Theme): string =>
        lighten(theme.palette.primary.main, 0.92),
    },
  },
  inputDefaultSelected: {
    "&.MuiChip-root": {
      backgroundColor: (theme: Theme): string =>
        lighten(theme.palette.primary.main, 0.8),
      color: COLORS.BLACK,
    },
  },
  inputDefaultSelectedWithIcon: {
    "&.MuiChip-root": {
      backgroundColor: (theme: Theme): string =>
        lighten(theme.palette.primary.main, 0.57), // .43
    },
  },
  choiceDefaultSelected: {
    "&.MuiChip-root": {
      backgroundColor: (theme: Theme): string =>
        lighten(theme.palette.primary.main, 0.76), // .24
      color: COLORS.BLACK,
    },
  },
  outlinedSelected: {
    "&.MuiChip-root&.MuiChip-outlined": {
      border: (theme: Theme): string =>
        `1px solid ${theme.palette.primary.main}`,
      color: COLORS.BLACK,
      backgroundColor: (theme: Theme): string =>
        lighten(theme.palette.primary.main, 0.92),
    },
  },
} as { [key: string]: SxProps };

export const iconOverlayStyles = {
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  position: "absolute",
  zIndex: 100,
} as SxProps;

export const iconWrapperStyles = {
  position: "relative",
  backgroundColor: COLORS.P_DISABLED,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& > *": {
    opacity: 0.5,
    width: "18px",
    height: "18px",
  },
} as SxProps;
